<template>
    <div class="field">
        <label for="tags">Tag *</label>
        <Dropdown id="tags" v-model="selectedTag" :options="allTags" optionLabel="code" optionValue="id" placeholder="Select a tag" :disabled="disabledState" @change="tagUpdated" />
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { attributeStore } from '../../../../../store/global-stores';

const { allTags } = storeToRefs(attributeStore);

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Array,
    },
});

const selectedTag = ref(null);
const disabledState = ref(false);

onMounted(() => {
    if (props.modelValue) {
        selectedTag.value = props.modelValue[0]?.id;
        disabledState.value = true;
        // emit('update:modelValue', { id: selectedTag.value?.tag_id });
    }
    loadTags();
});

onUnmounted(() => {
    disabledState.value = false;
    selectedTag.value = null;
});

const loadTags = async () => {
    await attributeStore.fetchAllTags();
};

const tagUpdated = () => {
    const tagData = selectedTag.value ? [{ id: selectedTag.value }] : [];
    emit('update:modelValue', tagData);
    loadAttributeData();
};

const loadAttributeData = async () => {
    // also trigger attribute data changes
    await attributeStore.loadAttributeFromTagId(selectedTag.value);
};
</script>
